import { get, post } from '../axios'

export function userSystem_detail_get(map) {
  return get(`${process.env.VUE_APP_UMS}/ums-admin/userSystem/detail`, map)
}

export function userSystem_save_post(map) {
  return post(`${process.env.VUE_APP_UMS}/ums-admin/userSystem/save`, map)
}
